<template>
  <header class="pmp-header">
    <div class="pmp-header-brand">
      {{ brand }}
    </div>

    <div class="pmp-stepper" aria-label="Progreso del formulario">
      <span
        v-for="n in totalSteps"
        :key="n"
        class="pmp-stepper-dot"
        :class="{ 'is-active': n === step, 'is-done': n < step }"
      ></span>
    </div>
  </header>
</template>

<script setup>
defineProps({
  brand: {
    type: String,
    default: 'Consumo de Materia Prima'
  },
  step: {
    type: Number,
    required: true
  },
  totalSteps: {
    type: Number,
    default: 6
  }
})
</script>
